export default {
  title: 'Usage records',
  description: 'Review how seat layouts have been used by activities and meetings.',
  export: 'Export records',
  totalRecords: '{count} usage records',
  layoutsUsed: '{count} layouts used',
  formsUsed: '{count} registration forms',
  allLayouts: 'All layouts',
  allForms: 'All forms',
  searchPlaceholder: 'Search layout, form, or activity',
  layout: 'Layout',
  form: 'Registration form',
  activity: 'Activity',
  usedAt: 'Used at',
  operator: 'Operator',
  view: 'View',
  empty: 'No usage records yet',
  importedRoster: 'Imported roster',
  exportSuccess: 'Usage records exported',
  back: 'Back',
  detailTitle: 'View seat arrangement',
  breadcrumbManage: 'Seat management',
  breadcrumbRecords: 'Usage records',
  properties: 'Properties',
  legendEmpty: 'Empty',
  legendAssigned: 'Assigned',
  canvasTip: 'Click a seat or table to view details (read only)',
  canvasActivity: 'Activity: {name}',
  canvasSession: 'Session: {name}',
  sortLabel: 'Sort',
  rosterAssigned: '{assigned} / {total} assigned',
  emptyRoster: 'No participants yet',
  sourceRegistration: 'Registration',
  sourceImported: 'Imported',
  selectSeatHintFirst: 'Click a seat or table',
  selectSeatHintSecond: 'to view details',
  progress: '{assigned} / {total} seats assigned',
  readonly: 'Read only',
  rosterTitle: 'Participant roster',
  rosterProgress: '{count} people',
  sortDefault: 'Default (unassigned first)',
  sortNameAsc: 'Name A-Z',
  sortNameDesc: 'Name Z-A',
  sortOrganization: 'Organization / name',
  sortSeat: 'Seat order',
  searchRoster: 'Search name / organization / job title',
  noOrganization: 'No organization',
  seatNo: 'Seat {no}',
  unassigned: 'Unassigned',
  seatProperties: 'Seat details',
  unit: 'Unit',
  row: 'Row',
  column: 'Column',
  seatNumber: 'Seat number',
  status: 'Status',
  assignedStatus: 'Assigned',
  emptyStatus: 'Empty',
  emptySeat: 'This seat is empty',
  selectSeatHint: 'Select a seat or table to view details'
}
